import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LOAN_SERVICES } from '@/utils/constants';

export default function Services() {
    return (
        <section className="services-section" id="services" data-testid="services-section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Our Services</h2>
                </div>
                <div className="services-grid">
                    {LOAN_SERVICES.map((service, index) => (
                        <Card key={index} className="service-card" data-testid={`service-card-${index}`}>
                            <div className="service-image" style={{ backgroundImage: `url(${service.image})` }} />
                            <CardHeader>
                                <CardTitle>{service.title}</CardTitle>
                                <CardDescription>{service.description}</CardDescription>
                            </CardHeader>
                            <CardContent>
                                <Link to={service.link}>
                                    <Button className="w-full" data-testid={`service-btn-${index}`}>Learn More</Button>
                                </Link>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};
